import { Card } from "../../design-v2";

export default function SettingsReadonlyScreen({
  eyebrow,
  title,
  description,
  showTitle = true,
  children,
}) {
  return (
    <div className="space-y-6">
      {showTitle ? (
        <div>
          {eyebrow ? <p className="lz-settings-header__eyebrow">{eyebrow}</p> : null}
          {title ? <h2 className="lz-settings-header__title">{title}</h2> : null}
          {description ? <p className="lz-settings-hint">{description}</p> : null}
        </div>
      ) : description ? (
        <p className="lz-settings-hint">{description}</p>
      ) : null}

      <Card tone="default" padding="md">
        {children}
      </Card>
    </div>
  );
}
